import React from 'react'
import { connect } from 'react-redux'
import { brand } from '../../../redux/app-selectors'
import { Icon } from '../../../atoms'

interface IReference {
  label: string
  url: string
  description: string
}
interface IFootNotesProps {
  name: string
  jsonBody: {
    title: string
    references: IReference[]
  }
  variant: string
  rawName: string
  sys: { id: string }
  showHeader: boolean
  brand: 'money' | 'uswitch'
}

const FootNotes = ({
  jsonBody,
  name,
  variant,
  sys,
  rawName,
  showHeader,
  brand,
}: IFootNotesProps) => {
  const { references, title } = jsonBody
  try {
    return (
      <div className='FootNotes' id={name}>
        {showHeader && <h3 className='FootNotes__title'>{title}</h3>}
        <div className='FootNotes__content'>
          {references.map(({ label, url, description }, index) => {
            return (
              <div key={index} className='FootNotes__content-item'>
                <span className='FootNotes__content-item-index'>{index + 1}. </span>
                <span>
                  <a
                    className='FootNotes__content-item-link'
                    href={url}
                    target={'_blank'}
                    rel='noreferrer'
                    /* eslint-disable camelcase */
                    data-click-tracking={JSON.stringify({
                      component_category: 'platinum-component',
                      component_id: sys?.id,
                      component_name: 'FootNotes',
                      contentful_name: rawName,
                      contentful_variant: variant,
                      additionalProps: { text: label, referenceUrl: url },
                    })}
                  >
                    {label}
                  </a>{' '}
                  <span>{description}</span>{' '}
                  <span>
                    <a
                      className='FootNotes__content-item-link'
                      target={'_blank'}
                      href={url}
                      rel='noreferrer'
                      /* eslint-disable camelcase */
                      data-click-tracking={JSON.stringify({
                        component_category: 'platinum-component',
                        component_id: sys?.id,
                        component_name: 'FootNotes',
                        contentful_name: rawName,
                        contentful_variant: variant,
                        additionalProps: { text: label, referenceUrl: url },
                      })}
                    >
                      <Icon
                        glyph={'external-link'}
                        size={8}
                        color={brand === 'money' ? '#924A8B' : '#141414'}
                      />
                    </a>
                  </span>
                </span>
              </div>
            )
          })}
        </div>
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default connect((state, props) => {
  return {
    brand: brand(state),
    ...props,
  }
})(FootNotes)
